export default __webpack_public_path__ + "static/media/630.5c0cf4f1.png";